<template>
  <div class="form-control">
    <div v-if="readonly">
      <template v-if="localValue.length">
        <v-chip v-for="v in localValue" :key="v" outline color="primary">
          {{ customLabel(v) }}
        </v-chip>
      </template>
      <template v-else>-</template>
    </div>
    <Multiselect
      v-else
      v-model="localValue"
      :options="computedOptions"
      :custom-label="customLabel"
      group-label="name"
      group-values="values"
      group-select
      multiple
      :close-on-select="false"
      :searchable="false"
      @input="emit()"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  props: {
    value: {
      type: Array,
      default: undefined
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: [...(this.value || [])],
      options: [
        {
          name: this.$t('Select All'),
          values: [
            { value: 'executive', text: this.$t('asset_wise.executive') },
            { value: 'broker', text: this.$t('asset_wise.broker') },
            { value: 'not login', text: this.$t('asset_wise.not_login') }
          ]
        }
      ]
    }
  },
  computed: {
    computedOptions() {
      return this.options.map((option) => ({
        ...option,
        values: option.values.map((groupOption) => groupOption.value)
      }))
    }
  },
  watch: {
    value(value) {
      this.localValue = [...value]
    }
  },
  methods: {
    customLabel(value) {
      return this.options
        .reduce((acc, option) => {
          acc.push(...option.values)
          return acc
        }, [])
        .find((option) => option.value === value).text
    },
    emit() {
      this.$emit('input', this.localValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/AssetWiseRoleSelect.vue